import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const LoadingIndicator = ({ isloading }) => {
  if (!isloading) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '10px',
      }}
    >
      <CircularProgress style={{ color: '#1e1e43' }} />
    </Box>
  );
};

export default LoadingIndicator;
